var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataOutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2000,
    viewBox: "0 0 2000 2000",
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1251.9355 207.89648c-286.2304.00065-572.46091.00096-858.69136.002v1584.21096h1213.51176v-1219.85549c-118.2735-121.45252-236.5469-242.90499-354.8204-364.35747zm-104.207 90v371.64844h369.0274v1032.56448h-1033.51176v-1404.21096c221.49479-.00065 442.98959-.00096 664.48436-.002zm90 24.41211 250.5039 257.23633h-250.5039zm-454.56053 42.60547v185.30274h-212.03516v159.54687h212.03516v185.30469l282.15043-265.07813z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOutput);
export default __webpack_public_path__ + "static/media/data-output.a4ccd16e0f9eb6d25fb5554e8587e7ec.svg";
export { ForwardRef as ReactComponent };